export const reportSizes = (chartType?: string) => {
  const defaults = {
    minW: 2,
    minH: 2,
    initialW: 2,
    initialH: 2,
  }

  switch (chartType) {
    case 'table':
      return {
        minW: 2,
        minH: 2,
        initialW: 4,
        initialH: 4,
      }
    case 'numeric_metric':
      return {
        ...defaults,
        minW: 1,
        initialW: 1,
      }
    case 'bars':
    case 'pie':
    case 'lines':
    case 'area':
    default:
      return defaults
  }
}
